import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import React, { createContext, useEffect, useState } from "react";
import { db } from '../firebase/config';

export const GlobalContext = createContext();

function GlobalProvider({children}){

    const [menu, setMenu] = useState(false)

    const [loadedData, setLoadedData] = useState(false)

    const [lang, setLang] = useState("")

    const [data, setData] = useState("")

    const [sectionList, setSectionList] = useState([""])

    const [section, setSection] = useState("")

    const [projectsData, setProjectsData] = useState([""])

    const [project, setProject] = useState("")

    if(sessionStorage.getItem("porfolioContacts") === undefined){
        sessionStorage.setItem("porfolioContacts", JSON.stringify([]))
    }
    const [contacts, setContacts] = useState(JSON.parse(sessionStorage.getItem("porfolioContacts")))

    const [resume, setResume] = useState([])

    const refreshData = () =>{
        if(lang === "" && sessionStorage.getItem("LJKLang") !== undefined){
            setLang(sessionStorage.getItem("LJKLang"))
        }

        if(data === "" && sessionStorage.getItem("LJKData") !== undefined){
            setData(JSON.parse(sessionStorage.getItem("LJKSectionList")))
        }

        if(sectionList[0] === "" && sessionStorage.getItem("LJKSectionList") !== undefined){
            setSectionList(JSON.parse(sessionStorage.getItem("LJKSectionList")))
        }

        setLoadedData(true)
    }

    if(!loadedData){
        refreshData()    
    }

    useEffect(() => {

    }, [lang])

    const getData = async (lang) => {
        let col

        if(lang === "ingles"){
            col = "projects"
            console.log("ingles");
            
        } else if(lang === "español") {
            col = "proyectos"
            console.log("español");
        } 

        let dat
            try{
                console.log("fetch");
                console.log(col);
                await getDocs(query(collection(db, col), orderBy("timestamp", "desc")))
                .then(resp => {
                    dat = resp.docs.map((doc) => ({id: doc.id, ...doc.data()}));
                })
            } catch(err){
                console.log(err);
            }
        sessionStorage.setItem("LJKData", JSON.stringify(dat))
        setData(JSON.parse(sessionStorage.getItem("LJKData")))
        getSectionList()
        getContact()
        getResume(lang)
    }

    const getSectionList = () => {
        let sec = []
        let d = JSON.parse(sessionStorage.getItem("LJKData"))
        for(let i = 0; i < d.length;i++){
            if(!sec.includes(d[i].section)){
                sec.push(d[i].section)
            }
        }

        sessionStorage.setItem("LJKSectionList", JSON.stringify(sec))  
        setSectionList(JSON.parse(sessionStorage.getItem("LJKSectionList")))      
    }

    const getProjectsData = (sec) =>{
        let s = []
        let d = JSON.parse(sessionStorage.getItem("LJKData"))
        d.forEach(proj => {
            console.log(proj.section);
            console.log(sec);
            if(proj.section === sec){
                s.push({id: proj.id, ...proj.data})
            }
        });
        console.log(s);
        sessionStorage.setItem("LJKProjectsData", JSON.stringify(s))
        setProjectsData(s)          
    }

    const getProject = (proj) => {
        projectsData.forEach(p => {
            console.log(p.id);
            console.log(proj);
            if(p.id === proj){
                console.log("igual");
                sessionStorage.setItem("LJKProject", JSON.stringify(p)) 
                setProject(JSON.parse(sessionStorage.getItem("LJKProject")))
            }
        })
    }


    const openMenu = () => {
        const select = document.querySelector(".navbar__select")

        if(menu){
            console.log("close");
            select.style.width = "0px"
            setTimeout(() => {
                document.querySelector(".selects__projects").style.display = "none"
                document.querySelector(".selects__links").style.display = "none"
                select.style.height= "0px"
            }, 350)
            setTimeout(() => {
                select.style.width= "5rem"
                select.left = 0
            }, 400)
            setMenu(false)
            console.log(menu);
        } else {
            console.log("open");
            select.style.width = "2px"
            setTimeout(() => {
                select.style.height= "17rem"
                select.style.borderRadius = "10px"
            }, 300)
            setTimeout(() => {
                document.querySelector(".selects__projects").style.display = "flex"
                document.querySelector(".selects__links").style.display = "flex"
            }, 200)
            setTimeout(() => {
                select.style.width= "100vw"
                select.left = 0
            }, 400)
            setMenu(true)
            console.log(menu);
        }       
    }

    const [idPrev, setIdPrev] = useState("")

    const showElement = (id) => {
        console.log("show", id);
        let subtitles = document.getElementsByClassName("listItem")
        let elements = document.getElementsByClassName("listDetail")
        
        for(let i = 0; i < elements.length; i++){
            elements[i].style.height = "0"
            let d = subtitles[i].innerHTML.replace("-", "+")
            subtitles[i].innerHTML = d
        }

        const subtitle = document.getElementById("sub" + id.split(' ').join(''))
        const element = document.getElementById(id.split(' ').join(''))
        
        if(idPrev === id){
            subtitle.innerHTML = id + " +"        
            element.style.height = "0"
            setIdPrev("")
        } else {
            subtitle.innerHTML = id + " -"        
            element.style.height = "auto"
            setIdPrev(id)
        }       
    }

    const getContact = async () => {
        let con
        const storage = getStorage();

        await getDocs(query(collection(db, "contacts")))
        .then(resp => {
            con = resp.docs.map((doc) => ({...doc.data()}));
            console.log(con);                
        })

        for(let j = 0; j < con[0].contact.length; j++){
            await getDownloadURL(ref(storage, con[0].contact[j].iconPath))
            .then((url) => {
                con[0].contact[j].iconPath = url
            })
        }

        for(let j = 0; j < con[0].network.length; j++){
            await getDownloadURL(ref(storage, con[0].network[j].iconPath))
            .then((url) => {
                con[0].network[j].iconPath = url
            })
        }
        
        sessionStorage.setItem("contacts", JSON.stringify(con[0]))
        setContacts(con[0])
    }

    const getResume = async (lang) => {
        let res
        console.log(lang);
        if(lang === "ingles"){
            res = "resume"
        } else if(lang === "español"){
            res = "curriculum"
        }

        console.log(res);
        try{
            await getDocs(query(collection(db, res), orderBy ("order", "asc")))
            .then(resp => {
                res = resp.docs.map((doc) => ({id: doc.id, ...doc.data()}));
                console.log(res);
                setResume(res)
            })
        } catch(err){
            console.log(err);
        }
    }

    return(
        <GlobalContext.Provider value={{
            lang,
            sectionList,
            section,
            projectsData,
            project,
            contacts,
            resume,
            setSection,
            setLang,
            openMenu,
            getData,
            getProjectsData,
            showElement,
            getProject,
        }}>
            {children}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider
